export const tabSelection = (function ($) {
    function init() {
        $(".js-tab").click(function () {
            let tabId = $(this).attr("data-id");
            // selected tab
            $(this).parent().find($(".js-tab")).removeClass("selected");
            $(this).addClass("selected");

            // selected tab content
            $(".js-tab-content_" + tabId).parent().find($(".js-tab-content")).hide().removeClass("animate slide-in-bottom animation-delay-0");
            $(".js-tab-content_" + tabId).show().addClass("animate slide-in-bottom animation-delay-0");

            // selected results
            $(".js-championship-results_" + tabId).parent().find($(".js-championship-results")).hide().removeClass("animate slide-in-bottom animation-delay-1");
            $(".js-championship-results_" + tabId).show().addClass("animate slide-in-bottom animation-delay-1");
        });
    }

    return {
        init: init,
    };
})(jQuery);
